var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "button",
        {
          staticClass: "btn btn-success",
          attrs: { type: "button" },
          on: { click: _vm.showModal }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.trans("menu_planner.macronutrient_report.name")) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("view-loader", { attrs: { loading: _vm.loading } }, [
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: {
              id: "modal",
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "modalLabel",
              "aria-hidden": "true"
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h3", { attrs: { id: "modalLabel" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.trans("menu_planner.macronutrient_report.header")
                        ) + "\n                            "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "aria-label": "Close"
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "col-form-label" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.macronutrient_report.date_from"
                                )
                              ) +
                              "\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("date-picker", {
                          attrs: { time: false },
                          model: {
                            value: _vm.dateFrom,
                            callback: function($$v) {
                              _vm.dateFrom = $$v
                            },
                            expression: "dateFrom"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "col-form-label" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.trans(
                                  "menu_planner.macronutrient_report.date_to"
                                )
                              ) +
                              "\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("date-picker", {
                          attrs: { time: false },
                          model: {
                            value: _vm.dateTo,
                            callback: function($$v) {
                              _vm.dateTo = $$v
                            },
                            expression: "dateTo"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.isValid
                      ? _c(
                          "div",
                          { staticClass: "error" },
                          _vm._l(_vm.errors, function(error) {
                            return _c("span", { key: error.message }, [
                              _vm._v(_vm._s(error.message)),
                              _c("br")
                            ])
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.generate }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.trans("form.generate")) +
                            "\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn default",
                        attrs: { type: "button", "data-dismiss": "modal" }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.trans("form.cancel")) +
                            "\n                        "
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fa293cc", { render: render, staticRenderFns: staticRenderFns })
  }
}